module.exports = __webpack_public_path__ + "img/T1B_rc_24.b70fcb7b.png";